import { render, staticRenderFns } from "./HotpointLink.vue?vue&type=template&id=675e73ba&scoped=true"
import script from "./HotpointLink.vue?vue&type=script&lang=js"
export * from "./HotpointLink.vue?vue&type=script&lang=js"
import style0 from "./HotpointLink.vue?vue&type=style&index=0&id=675e73ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675e73ba",
  null
  
)

export default component.exports